class ValidatorUtils {

  emailAddressIsValid(emailAddress) {

    return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.(?:[a-zA-Z]{2,})$/.test(emailAddress);

  }

}

export default ValidatorUtils;



// WEBPACK FOOTER //
// ./src/library/validators/ValidatorUtils.js